import { useMemo } from 'react';
import type { TaskBodyProps } from '../index';
import { DesignReviewFooter } from '../DesignReviewFooter';
import { DesignDxTaskLayout, PastSubmissions } from './DesignDxTaskLayout';
import { OPEN_DX_DRAFT, useDxDraftRequiredHint } from './useDxDraftRequiredHint';
import { useFinalReviewHandBack } from './useFinalReviewHandBack';
import { designLoopActions } from './designLoop';
import { useBeforeCloseFlush } from './useBeforeCloseFlush';

export function ReviewDesignFinalizeDxTask({
    workCase: c,
    statusMeta,
    onPayloadChange,
    onTaskComplete,
    onRegisterBeforeClose
}: TaskBodyProps) {
    const dxDraftHint = useDxDraftRequiredHint(c.id, OPEN_DX_DRAFT);
    const handBack = useFinalReviewHandBack(c.id);

    // The footer is ours, not TaskSurface's, so we flush pending Dx edits ourselves too.
    const { registerBeforeClose, flush: flushDx } = useBeforeCloseFlush(onRegisterBeforeClose);

    const { submitTypes } = designLoopActions(statusMeta.macro);
    const submissions = useMemo(
        () => <PastSubmissions patientId={c.id} submitTypes={submitTypes} handBack={handBack} />,
        [c.id, submitTypes, handBack]
    );

    return (
        <div className="flex-1 min-h-0 flex flex-col">
            <DesignDxTaskLayout
                workCase={c}
                statusMeta={statusMeta}
                submissions={submissions}
                onRegisterBeforeClose={registerBeforeClose}
                handBack={handBack}
            />
            <DesignReviewFooter
                caseId={c.id}
                statusMeta={statusMeta}
                onPayloadChange={onPayloadChange}
                onTaskComplete={onTaskComplete}
                primaryLabel="Send to final review"
                primaryDisabledHint={dxDraftHint}
                beforeAction={flushDx}
            />
        </div>
    );
}
